var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "M21.984 10.063v-.047H10.016V22.029l.08-.08 8.27-8.27a1.515 1.515 0 0 1 2.143 0l1.395 1.395.08.08V10.062ZM12.66 21.904l-.08.08h9.405V17.672l-.013-.013-2.5-2.5-.034-.033-.033.033-6.745 6.745ZM9.75 8.234h12.5a1.516 1.516 0 0 1 1.516 1.516v12.5a1.516 1.516 0 0 1-1.516 1.516H9.75a1.516 1.516 0 0 1-1.516-1.516V9.75A1.516 1.516 0 0 1 9.75 8.234Zm2.234 5.266a1.516 1.516 0 1 1 3.032 0 1.516 1.516 0 0 1-3.032 0Z"
  })));
};
export default SvgImage;